import { Stack } from '@mui/material';
import { Category, ICategory } from './Category';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Therapy } from 'Images';

export const Categories = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).lobby
    .categories;

  const categories: ICategory[] = [
    {
      image: Therapy,
      text: dictionary.therapy,
      url: '/suppliers/therapy',
    },
  ];

  return (
    <Stack
      direction='row'
      justifyContent='center'
      alignItems='center'
      columnGap='24px'
      rowGap={isDesktop ? '32px' : '16px'}
      flexWrap='wrap'
      sx={{
        m: '0 auto',
        maxWidth: '870px',
      }}
    >
      {categories.map((categoryItem: ICategory, index: number) => {
        return (
          <Category
            key={index}
            image={categoryItem.image}
            text={categoryItem.text}
            url={categoryItem.url}
          />
        );
      })}
    </Stack>
  );
};
